import { PencilLine, Cpu, FileCheck2 } from "lucide-react";
import Container from "@/components/ui/Container";
import Reveal from "@/components/common/Reveal";

const STEPS = [
  {
    icon: PencilLine,
    step: "01",
    title: "Describe the test",
    body: "Type a plain-English instruction and a URL — or tap a quick prompt like “Test login”.",
  },
  {
    icon: Cpu,
    step: "02",
    title: "AI runs it for real",
    body: "The planner turns it into steps, runs them in a real browser, and a judge model checks the outcome.",
  },
  {
    icon: FileCheck2,
    step: "03",
    title: "Get the result + bug",
    body: "See a step timeline with screenshots, a structured bug report, and the exact cost of the run.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      className="relative scroll-mt-20 border-y border-slate-200/70 bg-white py-20 dark:border-white/10 dark:bg-ink-900/40 sm:py-28"
    >
      <Container>
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-600 dark:text-brand-400">
            How it works
          </span>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
            Three steps. No scripts.
          </h2>
        </Reveal>

        <div className="relative mt-16 grid gap-8 md:grid-cols-3">
          {/* connecting line on desktop */}
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-brand-300/60 to-transparent dark:via-brand-500/30 md:block" />

          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.12} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="relative grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-600 text-white shadow-glow">
                  <s.icon size={24} />
                  <span className="absolute -right-2 -top-2 grid h-6 w-6 place-items-center rounded-full bg-white text-[0.6875rem] font-bold text-brand-600 shadow dark:bg-ink-900">
                    {s.step}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-semibold text-slate-900 dark:text-white">
                  {s.title}
                </h3>
                <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
